module.exports = __webpack_public_path__ + "static/media/1 04 hvete.9585164f.mp3";